import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantQr } from '../mutations/createParticipantQR.mutation';
import type { CreateParticipantQrMutation, CreateParticipantQrMutationVariables } from '../types';

export const useCreateParticipantQrMutation = (
  options?: MutationOptions<CreateParticipantQrMutation, CreateParticipantQrMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantQr), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
